module.exports = __webpack_public_path__ + "static/media/fundcorp-logo-mobile.3798e185.svg";